import React from 'react';
import styles from './AdditionalModal.module.scss';
import Modal from '@src/components/modal/Modal';
import TicketIcon from 'src/assets/icons/ticket.svg?react';
import Button from '@src/components/button/Button';

type Props = {
  open: boolean;
  onClose: () => void;
  onAdditionalExperience: () => void;
  onExitTicket: () => void;
};

function AdditionalModal(props: Props) {
  const { open, onClose, onAdditionalExperience, onExitTicket } = props;
  return (
    <Modal global={false} open={open} onClose={onClose} className={styles.wrapper} closeOnOverlayClick={false}>
      <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.normalText}>Do you have time for an</div>
        <div className={styles.title}>Extension Exercise?</div>
        <div className={styles.btnWrapper}>
          <Button label='Yes, Continue' size='small' color='green' className={styles.yesButton} onClick={onAdditionalExperience}/>
          <Button isLoading={false} label={'No, Go to'} boldLabel={'Exit Ticket'} size='small' className={styles.noButton} onClick={onExitTicket} leftIcon={undefined} rightIcon={<TicketIcon width={37} height={37} style={{marginLeft: '10px'}}/>}/>
        </div>
      </div>
    </div>
    </Modal>
  );
}

export default AdditionalModal;
